<span class="font-size-label">Font Size</span>

<div class="font-selection-controls">
  @if (isCollapsed()) {
    <button uiKitButton
      class="font-selection-button"
      size="small"
      color="secondary"
      theme="filled"
      (click)="onFontSizeChange(activeFontSize())"
      [title]="activeFontSizeTitle()"
    >
      {{ activeFontSizeLabel() }}
    </button>
  } @else {
    <button uiKitButton
      class="font-selection-button"
      size="small"
      color="secondary"
      [theme]="fontSize() === AppFontSize.SMALL ? 'filled' : 'ghost'"
      (click)="onFontSizeChange(AppFontSize.SMALL)"
      title="Small font (12px)"
    >
      S
    </button>

    <button uiKitButton
      class="font-selection-button"
      size="small"
      color="secondary"
      [theme]="fontSize() === AppFontSize.MEDIUM ? 'filled' : 'ghost'"
      (click)="onFontSizeChange(AppFontSize.MEDIUM)"
      title="Medium font (14px)"
    >
      M
    </button>

    <button uiKitButton
      class="font-selection-button"
      size="small"
      color="secondary"
      [theme]="fontSize() === AppFontSize.LARGE ? 'filled' : 'ghost'"
      (click)="onFontSizeChange(AppFontSize.LARGE)"
      title="Large font (16px)"
    >
      L
    </button>
  }
</div>
